import { Box, Container, Grid, GridItem, Image, Text } from "@chakra-ui/react";
import FeatureImg1 from "common/assets/img/Call.png";
import FeatureImg2 from "common/assets/img/Email.png";
import FeatureImg3 from "common/assets/img/checkCircle.png";
import { landingPageConstants } from "common/landingPageConstants";
import SubtitleIcon from "common/assets/img/subtitleIcon.png";
import DummyFormImg from "common/assets/img/dummyFormImg.png";

export const featureData = [
  {
    title: "Smart tools for daily productivity",
    description: "Manage communication and tasks effortlessly with tools like email, contacts, and to-dos all in one place.",
    features: [
      {
        icon: FeatureImg1,
        title: "Contact",
        desc: "Manage leads and client details in one organized place.",
      },
      {
        icon: FeatureImg2,
        title: "Emails",
        desc: "Send, track, and log email conversations seamlessly.",
      },
      {
        icon: FeatureImg3,
        title: "Tasks",
        desc: "Assign tasks and stay on top of to-dos with smart reminders.",
      },
    ],
    imageOnLeft: false,
  },
  {
    title: "Insights & automation that drive growth",
    description: "Make smarter decisions with dashboards, automation, and analytics all in one powerful CRM.",
    features: [
      {
        icon: FeatureImg1,
        title: "Contact",
        desc: "Manage leads and client details in one organized place.",
      },
      {
        icon: FeatureImg2,
        title: "Emails",
        desc: "Send, track, and log email conversations seamlessly.",
      },
      {
        icon: FeatureImg3,
        title: "Tasks",
        desc: "Assign tasks and stay on top of to-dos with smart reminders.",
      },
    ],
    imageOnLeft: true,
  },
];


const FeatureSection = () => {
  return (
    <>
      <Container maxW="container.xl">
      <Box className="featureSection" id="features">
        <Text className="iconSubtitle">
          <Image src={SubtitleIcon} height={"16px"} width={"16px"} alt="" /> Features
        </Text>
        <Box className="featureSectionTitlebox">
          <Text className="featureSectionTitle">
            {landingPageConstants.featureSectionTitle} <br /> {landingPageConstants.yourBusiness}
          </Text>
          <Text className="featureSectionDesc">
            {landingPageConstants.featureSectionDesc}
          </Text>
        </Box>
        <Box className="featureSectionRow">
          {featureData.map((section, index) => (
            <Grid
              key={index}
              templateColumns="repeat(2, 1fr)"
              gap={{base:"30px", md:"30px", lg:0}}
              alignItems="center"
             mt={index === 1 ? { base: "32px", md: "52px", lg: "72px" } : 0}
            >
              {section.imageOnLeft && (
                <GridItem colSpan={{base:2, md:2, lg:1}}>
                  <Box className="featureAnimBox">
                    <Image
                      src={DummyFormImg}
                      height="100%"
                      width="100%"
                      alt=""
                      className="featureAnimImg"
                    />
                  </Box>
                </GridItem>
              )}
              <GridItem colSpan={{base:2, md:2, lg:1}}>
                <Box className={`featureBox ${section.imageOnLeft ? "right" : ""}`}>
                  <Box className="featureContent">
                    <Text className="featureBoxTitle">{section.title}</Text>
                    <Text className="featureBoxDesc">{section.description}</Text>
                    <Box className="featureBoxList">
                      {section.features.map((item, idx) => (
                        <Box className="featureBoxListItem" key={idx}>
                          <Box className="featureItemImgBox">
                            <Image
                              src={item.icon}
                              height="24px"
                              width="24px"
                              objectFit="contain"
                              alt=""
                            />
                          </Box>
                          <Box className="featureItemContent">
                            <Text className="featureItemTitle">{item.title}</Text>
                            <Text className="featureItemDesc">{item.desc}</Text>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </Box>
                </Box>
              </GridItem>
              {!section.imageOnLeft && (
                <GridItem colSpan={{base:2, md:2, lg:1}}>
                  <Box className="featureAnimBox">
                    <Image
                      src={DummyFormImg}
                      height="100%"
                      width="100%"
                      alt=""
                      className="featureAnimImg"
                    />
                  </Box>
                </GridItem>
              )}
            </Grid>
          ))}
        </Box>
      </Box>
    </Container>
    </>
  );
};
export default FeatureSection;
